import React from "react";
import back from "../../assets/service-images/tech-back.webp";
import { Link } from "react-router-dom";
import image from "../../assets/home-images/Frame-line.svg";
import tick from "../../assets/service-images/tick.png";
import image1 from "../../assets/service-images/Frame5910.webp";
import AOS from "aos";
import "aos/dist/aos.css";

const TechnicalConsultation = () => {
  AOS.init({
    disable: function () {
      return window.innerWidth < 768; // Disable AOS for screens smaller than 768px (Tablets & Mobile)
    },

    // disable: false,
    startEvent: "DOMContentLoaded",
    initClassName: "aos-init",
    animatedClassName: "aos-animate",
    useClassNames: false,
    disableMutationObserver: false,
    debounceDelay: 50,
    throttleDelay: 99,

    // Smooth settings:
    offset: 80, // Slightly lower offset for a natural effect
    delay: 50, // Small delay for smoother animations
    duration: 600, // Increase duration for smoother animation
    easing: "ease-out", // Best easing for professional smoothness
    once: false, // Animation happens only once to avoid distraction
    mirror: false, // Prevents repeated animations when scrolling up
    anchorPlacement: "top-bottom",
  });
  return (
    <>
      {/* Section 1 */}
      <div
        className="bg-cover bg-center bg-no-repeat min-h-[502px] flex flex-col gap-8 justify-start px-6 py-16 md:px-8 lg:px-16"
        style={{ backgroundImage: `url(${back})` }}
      >
        <h1
          className="text-2xl md:text-3xl lg:text-3xl xl:text-5xl font-bold text-white w-full md:w-2/3 lg:w-2/5 xl:w-1/2"
          data-aos="fade-down"
        >
          Make Your Project Executions Effortless.
        </h1>
        <p
          className="text-white text-sm w-full md:w-2/3 lg:w-2/2 xl:w-[550px]"
          data-aos="fade-down"
        >
          Collaborate with Tekposiible's skilled technicians on your next
          project. Our certified experts provide technical leadership and
          architectural guidance, ensuring seamless execution and unparalleled
          value delivery.
        </p>
        <Link
          data-aos="zoom-in"
          data-aos-delay="300"
          to="/contact-us"
          className="w-[100px] w-fit sm:w-[150px] md:w-[140px] lg:w-[150px] bg-[#C32A7C] px-5 py-2 sm:px-6 sm:py-2.5 lg:px-0 lg:py-2 rounded-lg text-white  hover:bg-white hover:text-[#C32A7C] transition-colors duration-300 text-sm sm:text-sm md:text-sm lg:text-lg text-center whitespace-nowrap"
        >
          Contact Us
        </Link>
      </div>

      {/* Section 2 */}

      <div
        className="flex flex-col justify-around lg:flex-row items-center  px-6 py-16 md:px-8 lg:px-16 gap-10"
        data-aos="fade-up"
      >
        <div className="flex flex-col items-start w-full lg:w-1/2">
          <img
            src={image}
            alt="Illustration"
            className="max-w-xs md:max-w-sm"
          />
          <h1 className="text-[#1A5298] font-bold text-2xl md:text-2xl lg:text-3xl xl:text-3xl mt-5 w-full lg:w-[500px] xl:w-[554px]">
            What challenges can our technical consultants solve for you?
          </h1>
          <p className="mt-5 text-sm md:text-base w-full max-w-xl">
            Effectively design and implement processes within the ServiceNow
            application, aligning with User Stories and Acceptance Criteria.
          </p>
          <ul className="mt-5 space-y-3">
            {[
              "Technical Architecture",
              "Application Customization",
              "Integration",
              "Script Development",
              "Development",
              "Module Testing",
            ].map((item, index) => (
              <li
                key={index}
                className="flex items-center gap-4 text-sm md:text-base"
              >
                <img src={tick} alt="Tick" className="w-5 h-5" />
                <span>{item}</span>
              </li>
            ))}
          </ul>
        </div>

        <div className="flex">
          <img
            className="w-48 h-48 md:w-56 md:h-56 lg:w-[480px] lg:h-[430px]"
            src={image1}
            alt="Technical Illustration"
          />
        </div>
      </div>

      {/* Section 3 */}

      <div
        className="bg-[#FFFFFF] w-full py-8 md:py-16 mt-6"
        data-aos="fade-down-right"
      >
        <div className="flex flex-col items-center text-center px-4 md:px-6">
          <h1 className="text-[#1A5298] font-bold text-sm md:text-2xl lg:text-4xl text-center mb-8 w-full md:w-2/3 lg:w-3/4 xl:w-3/5">
            Ready to experience seamless project workflows guided by our
            experts?
          </h1>

          <Link
            data-aos="zoom-in"
            data-aos-delay="300"
            to={"/contact-us"}
            className="w-[140px] px-6 py-2 md:px-4 md:py-2.5 bg-[#C32A7C] rounded-lg text-white font-bold 
                             hover:bg-[#F6F6F6] hover:text-[#C32A7C] transition-colors duration-300 text-sm md:text-base 
                             text-center whitespace-nowrap mt-4 border border-[#C32A7C]"
          >
            Contact us
          </Link>
        </div>
      </div>
    </>
  );
};

export default TechnicalConsultation;
